<i class="fa-ban fas padding-right-10" data-toggle="tooltip" placement="left"></i>